export const scrollToPricing = () => {
  const element = document.getElementById('precio')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
